import { BasicPermissionItem } from '../../PermissionItem'
import { Simple } from '../../common'
import { ConcreteTestSets } from '../../../cimsPage/instances/concrete'

const page = ConcreteTestSets

export const EditConcreteBreakData = new BasicPermissionItem({
  id: '7b326c2d-9809-4592-8804-bbc03d3b655f',
  name: 'Edit Concrete Break Data',
  action: 'create, edit, and remove concrete break data',
  page,
})

/** Only read because this is a Mobile App Table */
export const ViewConcreteTestSet = Simple({
  id: 'f130c9ed-9ef6-4ee4-8322-441a08515676',
  action: 'View',
  object: 'Concrete Test Set',
  page,
})

export const EditAssociatedDocumentChecklistItem = new BasicPermissionItem({
  id: 'bf11fdc1-3570-41a4-ba6d-2c8b0092f7f8',
  name: 'Edit Associated Document Checklist Item',
  action: "check or uncheck a concrete test set's document checklist items",
  page,
})

/** Does not necessarily give you access to PDF Reports */
export const CreateConcretePacket = Simple({
  id: '7bd30638-cc80-4645-97ac-8defbecdcada',
  action: 'Create',
  object: 'Concrete Packet',
  page,
})

const object = 'Concrete Packet File'

export const UploadConcretePacketFile = new BasicPermissionItem({
  id: 'cc4a9dc3-fbc1-43ef-a982-c1d23c63103d',
  action: `upload ${object}s`,
  name: `Upload ${object}`,
  page,
})

export const ViewConcretePacketFile = Simple({
  id: 'e79e25df-348a-4983-adda-2f3a895d8078',
  action: 'View',
  object,
  page,
})

export const RemoveConcretePacketFile = Simple({
  id: 'f7e0d77c-f5a2-4dee-ade7-e17b6a386580',
  action: 'Remove',
  object,
  page,
})

export type ConcreteTrackerPermission =
  | typeof EditConcreteBreakData
  | typeof ViewConcreteTestSet
  | typeof EditAssociatedDocumentChecklistItem
  | typeof CreateConcretePacket
  | typeof UploadConcretePacketFile
  | typeof ViewConcretePacketFile
  | typeof RemoveConcretePacketFile
